import React from "react";
import { v4 as uuid } from 'uuid';

import { postTypeToString, registrationStateToString } from '../../../../../Utils/Converters';

function OrganiserRow(props) {
    const { post, name, state } = props;

    return (
        <tr key={uuid()}>
            <td>{postTypeToString(post)}</td>
            <td>{name}</td>
            <td>{registrationStateToString(state)}</td>
        </tr>
    );
}

export default OrganiserRow;